<i18n>
{
  "no": {
    "TOO_MANY_USERS": "Fant for mange brukere. Vennligst kontakt support",
    "TITLE": "Glemt passord",
    "SUCCESS": "Hvis brukernavnet finnes, sendes det om kort tid instruksjoner om tilbakestilling til registrert e-post. Vennligst gå tilbake til",
    "LOGIN" : "innlogging"
  },
  "en": {
    "TOO_MANY_USERS": "Found too many users. Please contact support.",
    "TITLE": "Forgot password",
    "SUCCESS": "If the username exists we will send password reset instructions to the registered email. Please go back to",
    "LOGIN" : "log in"
  }
}
</i18n>

<template>
  <div class="page">
    <FormWrapper>
      <div>
        <TnHeading type="h1" size="l" align="center" class="margin-vertical-2xl">
          {{ t('TITLE') }}
        </TnHeading>

        <ErrorMessage :error="error" />

        <ForgotPasswordForm v-if="!successSent" @form-submitted="onSubmitUsername" />

        <TnParagraph v-else size="s">
          {{ t('SUCCESS') }}
          <TnLink :to="{ name: 'elv-login', query: { request } }" :text="t('LOGIN')" />
        </TnParagraph>
      </div>
    </FormWrapper>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { TnHeading, TnLink, TnParagraph } from '@telenornorgeinternal/telegrafen-vue3-core';

import FormWrapper from '@/components/FormWrapper.vue';
import ForgotPasswordForm from '../components/forgotPasswordForm.vue';
import ErrorMessage from '@/views/elvis/components/errorMessage.vue';
import { forgotPassword } from '../api';

const { t } = useI18n();
const route = useRoute();

const error = ref<unknown>(null);
const successSent = ref(false);

const request = computed(() => (route.query.request as string) || '');

function onSubmitUsername(username: string) {
  error.value = null;
  forgotPassword(username)
    .then(() => (successSent.value = true))
    .catch((err) => (error.value = err));
}
</script>
